import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface EditorialGridLayoutProps {
  children: React.ReactNode;
}

const EditorialGridLayout: React.FC<EditorialGridLayoutProps> = ({ children }) => {
  const { theme } = useTheme();
  
  return (
    <div 
      className="relative transition-colors duration-300" 
      style={{ backgroundColor: theme === 'dark' ? '#111111' : '#FCFCF9' }}
    >
      {/* Content */}
      <div className="relative z-0">
        {children}
      </div>
    </div>
  );
};

export default EditorialGridLayout;
